// extracted by mini-css-extract-plugin
export default {"checkbox":"SonarSwitch_checkbox__qEshx","sonarBtn":"SonarSwitch_sonarBtn__iE2xH","ripple":"SonarSwitch_ripple__+XMSW"};